/**
 * The "unplanned" lifecycle status id. The board's status picker offers every status, but selecting this
 * one is treated as unplanning the item (with confirmation) rather than a plain status change — the shell
 * routes it to the unplan flow, and the backend rejects it on the change-status endpoint. Mirrors the
 * domain's `WorkOrderStatusRules` (which also forbids reaching "Planned" from an unplanned state).
 */
export const WORK_ORDER_NOT_PLANNED_STATUS_ID = 'NotPlanned';
